import { factoryService, getJsonRequest } from '@chilecompra/react-kit/requests'
import { REACT_APP_API_BASE_URL } from '../config/settings/environment'
import { normalizeDniSlashes } from '../modules/utils/normalizeForeignDni'

/**
 * Gets the seller legal suitability information
 */
export const getLegalSuitability = factoryService(({ dni, isForeign }) => {
  return getJsonRequest(
    `${REACT_APP_API_BASE_URL}/v1/proveedor/idoneidad/legal/${normalizeDniSlashes(dni)}/${isForeign}`
  )
})
